import React from 'react';

import { IApiOffer } from 'types/interfaces/IOffer';

import formatNumber from 'utils/formatNumber';

const FinancingLabeledNumber = ({
  value,
  countryCode,
  title,
}: {
  value: number | undefined;
  countryCode: IApiOffer['country']['code'];
  title: string;
}) => (
  <div>
    <strong>
      {formatNumber(value, countryCode, {
        withCurrency: false,
        minimumFractionDigits: 0,
      })}
    </strong>
    <h3 className='opacity-40' dangerouslySetInnerHTML={{ __html: title }} />
  </div>
);

export default FinancingLabeledNumber;
